module.exports = __webpack_public_path__ + "static/media/process.cac4b38f.svg";